import camelCase from 'lodash/camelCase';
import React, { useContext } from 'react';
import { Button, Icon, Link } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import { ModelExplorationContext } from '../ModelExplorationContext';
import { wrapJSSFields } from '../../utils/wrapJSSFields';
import { useAppName } from '../../utils/sitecoreContext';
import { PE_SITE_NAME } from '../../utils/constants';
const CTA = ({ linkField, typeField, iconField, icon, iconColor, parentGtmTags, ...otherProps }) => {
    const modelExplorationContext = useContext(ModelExplorationContext) || {};
    const { isDark } = modelExplorationContext;
    const styling = camelCase(typeField === null || typeField === void 0 ? void 0 : typeField.value);
    // TODO: Temporary fix for PE. Fix the tertiaryLink for PE (PSP Theme) in DSR later.
    let tertiaryLink = 'primary';
    const appName = useAppName();
    switch (appName) {
        case PE_SITE_NAME:
            tertiaryLink = styling === 'tertiary' ? 'tertiary2' : 'primary';
            break;
        default:
            break;
    }
    const { fields: wrappedIcon } = wrapJSSFields(iconField);
    const iconName = icon || (wrappedIcon === null || wrappedIcon === void 0 ? void 0 : wrappedIcon.getProp('value'));
    const darkStyling = styling === 'secondary' ? 'specialSecondary' : 'special';
    if (styling === 'tertiary' || styling === 'tertiaryWhite') {
        return (React.createElement("span", { ...parentGtmTags },
            React.createElement(Link, { styling: isDark || styling === 'tertiaryWhite' ? 'white' : tertiaryLink, as: RoutableSitecoreLink, field: linkField, ...otherProps }),
            iconName && React.createElement(Icon, { ml: "xs", height: "10px", iconColor: isDark ? 'red' : iconColor || 'primary', name: iconName })));
    }
    return (React.createElement(Button, { styling: isDark ? darkStyling : styling, as: RoutableSitecoreLink, field: linkField, ...otherProps }));
};
export default CTA;
